import MyCourseActionTypes from './myCourse.types';

export const setInitialCourseDetails = (text) => ({
	type: MyCourseActionTypes.SET_INITIAL_COURSE_DETAILS,
	payload: text,
});

export const updateCourseDetails = () => ({
	type: MyCourseActionTypes.FETCH_COURSE_DETAILS.PENDING,
});

export const fetchInstruction = ({
	elementId,
	courseId,
	completed,
	childToken,
}) => ({
	type: MyCourseActionTypes.FETCH_INSTRUCTIONS.PENDING,
	payload: { elementId, courseId, completed, childToken },
});

export const fetchAttempt = ({ attemptId, review = false }) => ({
	type: MyCourseActionTypes.FETCH_ATTEMPT.PENDING,
	payload: { attemptId, review },
});

export const fetchTaskList = () => ({
	type: MyCourseActionTypes.FETCH_TASK_DETAILS.PENDING,
});

export const fetchCallHistory = () => ({
	type: MyCourseActionTypes.FETCH_CALL_HISTORY.PENDING,
});

export const submitAssignment = () => ({
	type: MyCourseActionTypes.SUBMIT_ASSIGNMENT.PENDING,
});

export const changeFileValue = (file) => ({
	type: MyCourseActionTypes.SET_FILE_VALUE,
	payload: file,
});

export const changeFileError = (text) => ({
	type: MyCourseActionTypes.SET_FILE_ERROR,
	payload: text,
});

export const rescheduleCall = () => ({
	type: MyCourseActionTypes.RESCHEDULE_CALL.PENDING,
});

export const setCancelReason = (text) => ({
	type: MyCourseActionTypes.SET_CANCEL_REASON,
	payload: text,
});

export const resetUnitRequested = () => ({
	type: MyCourseActionTypes.RESET_UNIT_ID,
});

export const setScheduleId = (id) => ({
	type: MyCourseActionTypes.SET_SCHEDULE_ID,
	payload: id,
});

export const updateGrade = () => ({
	type: MyCourseActionTypes.CHANGE_GRADE.PENDING,
});

export const handleInputChange = (event) => ({
	type: MyCourseActionTypes.HANDLE_INPUT_CHANGE,
	payload: event,
});

export const generateCertificate = (name) => ({
	type: MyCourseActionTypes.GENERATE_CERTIFICATE.PENDING,
	payload: name,
});

export const getUpNext = () => ({
	type: MyCourseActionTypes.GET_UPNEXT.PENDING,
});

export const setShowTestInstr = (val) => ({
	type: MyCourseActionTypes.SET_SHOW_TESTINSTRUCTION,
	payload: val,
});

export const setShowGrade = (val) => ({
	type: MyCourseActionTypes.SET_SHOW_GRADE,
	payload: val,
});

export const setShowCancelReason = (val) => ({
	type: MyCourseActionTypes.SET_SHOW_CANCEL_REASON,
	payload: val,
});

export const setShowInfo = (val) => ({
	type: MyCourseActionTypes.SET_SHOW_INFO,
	payload: val,
});

export const setActiveKey = (val) => ({
	type: MyCourseActionTypes.SET_ACTIVE_UNIT,
	payload: val,
});

export const setPreviewMode = (val) => ({
	type: MyCourseActionTypes.SET_PREVIEW_MODE,
	payload: val,
});
